import { Participant } from "../Models/Participant";
import Connector from "../SignalR/signalR-connection";
import { fetchParticipants } from "./ParticipantService";

const { ShowResults, ShowVote } = Connector();

export async function finishVoting(participants: Participant[], votingId: string) {
  const validVotes = participants.filter((p) => p.vote !== -1).map((p) => p.vote);
  var averageVote = 0;
  if (validVotes.length !== 0) {
    averageVote = validVotes.reduce((tot, vote) => tot + vote, 0) / validVotes.length;
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_UPDATEVOTING}${votingId}${process.env.REACT_APP_API_UPDATEVOTINGCODE}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          result: averageVote,
          isActive: false,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const updatedVoting = await response.json();
    ShowResults(updatedVoting.id, updatedVoting.result);

    console.log("Voting finished:", updatedVoting);
  } catch (error) {
    console.error("Error finishing voting:", error);
  }
}

export async function updateVote(
  participantId: string | null,
  vote: number,
  setVotingDetails: React.Dispatch<any>
): Promise<Participant[] | undefined> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_UPDATEPARTICIPANT}${participantId}${process.env.REACT_APP_API_UPDATEPARTICIPANTCODE}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ vote }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const updatedParticipant: Participant = await response.json();
    const Participants: Participant[] = await fetchParticipants(
      updatedParticipant.votingId,
      setVotingDetails
    );
    ShowVote(updatedParticipant.votingId);
    return Participants;
  } catch (error) {
    console.error("Error updating vote:", error);
    return;
  }
}

export async function createNewVoting(
  setIsCreating: React.Dispatch<React.SetStateAction<boolean>>,
  newVotingTitle: string,
  userName: string
) {
  console.log("Creating new.");

  setIsCreating(true);
  const body = {
    title: newVotingTitle,
    creator: userName,
  };
  try {
    const response = await fetch(`${process.env.REACT_APP_API_CREATEVOTINGS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("New voting created:", data);
    window.location.href = `${window.location.origin}/${data.id}`;
    setIsCreating(false);
  } catch (error) {
    console.error("Error creating new voting:", error);
  }
}

export async function fetchVotingDetails(votingId: string): Promise<any> {
  const response = await fetch(
    `${process.env.REACT_APP_API_GETVOTING}${votingId}${process.env.REACT_APP_API_GETVOTINGCODE}`
  );
  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    console.error("Failed to fetch voting details");
  }
}

export async function fetchHistory(): Promise<any[]> {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_GETALLVOTINGS}`);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    const sortedHistory: any[] = [...data].sort((a: any, b: any) => {
      return Number(new Date(b.date)) - Number(new Date(a.date));
    });

    return sortedHistory;
  } catch (error) {
    console.error("Error fetching history:", error);
    return [];
  }
}
